import { Injectable } from '@angular/core';
import { catchAndGetFromFailureRxOp } from '@geekbears/gb-ngrx-stack-base';
import { Actions, createEffect, EffectsModule, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { SuperAdminHomeServices } from '../../domain/services/superadmin-home.service';
import { SuperAdminHomeActions } from './superadmin-home.actions';

@Injectable()
export class SuperAdminHomeEffects {
  constructor(
    private actions$: Actions,
    private superAdminHomeService: SuperAdminHomeServices
  ) {}

  allCustomers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SuperAdminHomeActions.getAllCustomers),
      mergeMap((action) => {
        return this.superAdminHomeService.getAllCustomers().pipe(
          map((users) =>
            SuperAdminHomeActions.getAllCustomersSuccess({ users })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            SuperAdminHomeActions.getAllCustomersFailure({ failure })
          )
        );
      })
    );
  });
  allActiveUsers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SuperAdminHomeActions.getAllActiveUsers),
      mergeMap((action) => {
        return this.superAdminHomeService.getAllActiveUsers().pipe(
          map((users) =>
            SuperAdminHomeActions.getAllActiveUsersSuccess({ users })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            SuperAdminHomeActions.getAllActiveUsersFailure({ failure })
          )
        );
      })
    );
  });

  notifications$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SuperAdminHomeActions.getNotifications),
      mergeMap((action) => {
        const { type, ...params } = action;
        return this.superAdminHomeService.getNotifications(params).pipe(
          map((notifications) =>
            SuperAdminHomeActions.getNotificationsSuccess({ notifications })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            SuperAdminHomeActions.getNotificationsFailure({ failure })
          )
        );
      })
    );
  });

  notificationsCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SuperAdminHomeActions.getNotificationsCount),
      mergeMap((action) => {
        const { type, ...params } = action;
        return this.superAdminHomeService.getNotificationsCount(params).pipe(
          map((response) =>
            SuperAdminHomeActions.getNotificationsCountSuccess({ response })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            SuperAdminHomeActions.getNotificationsCountFailure({ failure })
          )
        );
      })
    );
  });
  fetchNotifications$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SuperAdminHomeActions.fetchNotifications),
      mergeMap((action) => {
        const { type, ...params } = action;
        // console.log(action);
        return [
          SuperAdminHomeActions.getNotifications(params),
          SuperAdminHomeActions.getNotificationsCount(params),
        ];
      })
    );
  });

  markAsReadNotification$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SuperAdminHomeActions.markAsReadNotification),
      mergeMap((action) => {
        return this.superAdminHomeService
          .markAsReadNotification(action.notificationId)
          .pipe(
            map((response) =>
              SuperAdminHomeActions.markAsReadNotificationSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              SuperAdminHomeActions.markAsReadNotificationFailure({ failure })
            )
          );
      })
    );
  });
}
export const SuperAdminHomeEffectsModule = EffectsModule.forFeature([
  SuperAdminHomeEffects,
]);
